import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';

import { BalanceReminders } from './-balance-reminders';

export const Route = createFileRoute(
  '/researchers/_authenticated/billing/reminders',
)({
  component: BillingRemindersPage,
  head: () => ({ meta: [{ title: t`Balance reminders` }] }),
});

function BillingRemindersPage() {
  const { user, activeDashboard } = Route.useRouteContext();
  const teamId = activeDashboard.team ?? '';
  const organizationId = activeDashboard.organization ?? '';

  return (
    <>
      <h1 className="text-display-xs font-semibold text-primary">
        <Trans>Balance reminders</Trans>
      </h1>
      {teamId && organizationId && (
        <BalanceReminders
          organizationId={organizationId}
          teamId={teamId}
          userId={user.id}
        />
      )}
    </>
  );
}
